import React from 'react';
import SocialNetwork from './SocialNetwork';

const SocialNetworkPage: React.FC = () => {
  return <SocialNetwork />;
};

export default SocialNetworkPage;
